import { ServicioPnp } from "../../../base/js/servicioPnp";
import { ServicioProxy } from "../../../base/js/servicioProxy";
import { SaludValidaciones } from "../../../base/js/saludValidaciones";

class EnviarSimulacionFormulario extends React.Component {
  constructor(props) {
    super(props);

    this.pnpService = new ServicioPnp();

    this.state = {
      container: true,
      form: this.createForm(),
      isSubmitted: false,
      typeDocList: [],
      shedule: {},
      isDisabled: true,
      carousel: {
        settings: {
          dots: false,
          arrows: true,
          speed: 500,
          initialSlide: 0,
          slidesToShow: 3,
          slidesToScroll: 1,
          nextArrow: <NextArrow />,
          prevArrow: <PrevArrow />,
          variableWidth: false,
          focusOnSelect: false,
          infinite: false,
          centerMode: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 812,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 736,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 375,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 360,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 320,
              settings: {
                slidesToShow: 2,
              },
            },
          ],
        },
        isActive: false,
        itemSelected: {},
        hourSelected: "",
      },
      currentMessage: true,
      monthName: "",
      registeredNumber: 0,
    };

    this.errorMessages = {
      required: "es requerido",
      maxlength: "ha excedido del valor maximo permitido",
      email: "Por favor ingrese una dirección de correo",
      equalTo: "No es igual al correo personal",
      number: "solo permite números",
      isEmailRequired: "es requerida",
      minlength: "debe contener un mínimo de 10 dígitos",
      alphanumeric: "No permite caracteres especiales",
    };

    this.createForm = this.createForm.bind(this);
    this.setRulesForm = this.setRulesForm.bind(this);
    this.saludValidaciones = new SaludValidaciones(
      this.state.form,
      this.setRulesForm()
    );
    this.callPNPService = this.callPNPService.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.setFormdata = this.setFormdata.bind(this);
    this.selectedDate = this.selectedDate.bind(this);
    this.activeHours = this.activeHours.bind(this);
    this.updateName = this.updateName.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.getsubscribed = this.getsubscribed.bind(this);
    this.getDocType = this.getDocType.bind(this);
    this.setCursorAtBegin = this.setCursorAtBegin.bind(this);

    $(window).keyup((e) => {
      var code = e.keyCode ? e.keyCode : e.which;
      if (
        code == 9 &&
        $("#confirmEmail:focus").length &&
        $("#confirmEmail").val() == "@"
      ) {
        const input = document.getElementById("confirmEmail");
        input.setSelectionRange(0, 0);
      }
    });
  }

  componentDidMount() {
    this.callPNPService();
  }

  callPNPService() {
    this.pnpService.getListWithTop(
      "horarioContacto",
      (list) => {
        let shedule = [];
        let sheduleSort = [];
        const currentDate = new Date();
        let sheduleSortLength = 0;
        let monthName = moment(currentDate).format("MMMM", true);
        this.setState({ monthName: monthName });

        function compare(a, b) {
          var dateA = new Date(a.CSCalendarioDateTime),
            dateB = new Date(b.CSCalendarioDateTime);
          return dateA - dateB;
        }

        function removeDuplicateDate(arr) {
          let unique_array = [];
          let arraySize = 0;
          if (arr.length >= 7) {
            arraySize = 7;
          } else {
            arraySize = arr.length;
          }

          for (let i = 0; i < arraySize; i++) {
            if (arr[i + 1]) {
              if (arr[i + 1].date.getDate() !== arr[i].date.getDate()) {
                unique_array.push(arr[i]);
              }
            } else {
              unique_array.push(arr[i]);
            }
          }
          return unique_array;
        }

        list.sort(compare).map((item, key) => {
          let date = new Date(item.CSCalendarioDateTime);
          let createdDate = new Date(item.Created);
          const monthName = moment(date).format("MMMM", true);
          let weekStart = new Date(item.CSCalendarioDateTime);
          date = new Date(date.getTime() - date.getTimezoneOffset() * -60000);
          createdDate = new Date(
            createdDate.getTime() - createdDate.getTimezoneOffset() * -60000
          );
          weekStart.setDate(weekStart.getDate() - weekStart.getDay());
          let weekEnd = new Date(+weekStart);
          weekEnd.setDate(weekEnd.getDate() + 6);
          if (
            date.setHours(0, 0, 0, 0) > currentDate.setHours(0, 0, 0, 0) &&
            date.setHours(0, 0, 0, 0) - currentDate.setHours(0, 0, 0, 0) !== 0
          ) {
            sheduleSort.push({
              month: monthName,
              date: date,
              hours: item.CSHorarioMultiChoice.results,
              weekStart: weekStart,
              weekEnd: weekEnd,
              monthVisible: true,
            });
          }
        });

        sheduleSort = removeDuplicateDate(sheduleSort);
        sheduleSortLength = sheduleSort.length;

        sheduleSort.map((item, key) => {
          let date = item.date;
          let checkWeek =
            key + 1 !== sheduleSortLength && sheduleSort[key + 1].weekStart
              ? sheduleSort[key + 1].weekStart
              : sheduleSort[key].weekStart;
          if (item.weekStart - checkWeek === 0 && item.weekStart) {
            shedule.push({
              month: item.month,
              date: date,
              hours: item.hours,
              line: false,
              monthVisible: item.monthVisible,
            });
          } else {
            shedule.push({
              month: item.month,
              date: date,
              hours: item.hours,
              line: true,
              monthVisible: item.monthVisible,
            });
          }
        });
        this.setState({
          shedule,
        });
      },
      365
    );

    this.pnpService.getList("tiposDocumento", (list) => {
      this.setState({ typeDocList: list }, () => {
        if (this.props.form) {
          this.setFormdata(this.props.form);
        }
      });
    });
  }

  createForm() {
    const formProperties = [
      "fullName",
      "identificationType",
      "identificationNumber",
      "phone",
      "email",
      "confirmEmail",
      "isContacted",
      "confirmPersonalData",
      "confirmEmailMessage",
      "confirmTextMessage",
    ];
    let formObject = {};
    let formArray = formProperties.map((property) => {
      formObject[property] = { value: "" };

      if (property === "identificationType") {
        formObject["identificationType"]["value"] = "Seleccionar";
        formObject["identificationType"]["valid"] = false;
      }
      if (property === "isContacted") {
        formObject["isContacted"]["value"] = true;
      }
      if (property === "confirmPersonalData") {
        formObject["confirmPersonalData"]["value"] = true;
      }
      if (property === "confirmEmailMessage") {
        formObject["confirmEmailMessage"]["value"] = true;
      }
      if (property === "confirmTextMessage") {
        formObject["confirmTextMessage"]["value"] = true;
      }
    });
    formObject["isValid"] = false;
    return formObject;
  }

  setFormdata(data) {
    let form = this.state.form;
    data.name
      ? (form["fullName"].value = data.name.value)
      : (form["fullName"].value = "");
    data.email
      ? (form["email"].value = data.email.value)
      : (form["email"].value = "");
    data.identificationType
      ? (form["identificationType"] = data.identificationType)
      : (form["identificationType"].value = "");
    data.identificationNumber
      ? (form["identificationNumber"].value = data.identificationNumber.value)
      : (form["identificationNumber"].value = "");
    data.phone
      ? (form["phone"].value = data.phone.value)
      : (form["phone"].value = "");
    // data.documentNumber ? form['identificationNumber'].value = data.documentNumber.value : form['identificationNumber'].value = '';
    if (data.documentType) {
      const typeDocList = this.state["typeDocList"];
      let typeDoc = typeDocList.find(
        (elem) => elem.CSIdDocumentoText === data.documentType.value
      );
      form["identificationType"].value = typeDoc.CSDocumentoIdentidadText;
      form["identificationType"].valid = true;
    }
    this.setState({ form: form });
  }

  getsubscribed(subscribed) {
    let subscribedTemp = [];
    subscribed.map((person) => {
      subscribedTemp.push({
        Nombre: person.form.name.value,
        Categoria: person.form.cajaCategory.value,
        EPSCompensar: person.form.eps.value ? "8" : "111",
        TipoDeDocumento: person.form.documentType
          ? this.getDocType(person.form.documentType.value)
          : null,
        NumeroDeDocumento: person.form.documentNumber
          ? person.form.documentNumber.value
          : "",
        Edad: person.form.age ? person.form.age.value : 0,
        Genero: person.form.gender ? person.form.gender.value : null,
        Parentesco: person.form.relationship
          ? person.form.relationship.value
          : "",
      });
    });
    return subscribedTemp;
  }

  getDocType(docType) {
    if (docType !== "Seleccionar") {
      const typeDocList = this.state["typeDocList"];
      let typeDoc = typeDocList.find(
        (elem) =>
          elem.CSDocumentoIdentidadText === docType ||
          elem.CSIdDocumentoText === docType
      );
      return typeDoc.CSSiglaText;
    } else {
      return null;
    }
  }

  setRulesForm() {
    const email = this.state.form.email.value;
    const rules = {
      fullName: {
        required: true,
        maxlength: 105,
      },
      email: {
        email: true,
      },
      confirmEmail: {
        email: true,
        equalTo: (value) => {
          return (
            value.trim().toLowerCase() ===
            this.state.form.email.value.trim().toLowerCase() &&
            this.state.form.email.value.trim().toLowerCase()
          );
        },
        required: () => {
          return this.state.form.email.value;
        },
      },
      identificationNumber: {
        maxlength: 60,
        required: true,
        alphanumeric: (value) => {
          return (
            /^[ _]*[a-zA-Z0-9  áéíóúÁÉÍÓÚñÑ]*$/.test(value) &&
            value.trim() != ""
          );
        },
      },
      identificationType: {
        required: true,
      },
      phone: {
        required: true,
        maxlength: 10,
        number: true,
        minlength: 10,
      },
    };
    return rules;
  }

  removeNonLetters(string) {
    const regex = /[^a-zA-Z\s]/gi;
    return string.replace(regex, "");
  }

  handleInputChange(event) {
    if (event) {
      const target = event.target;
      const value = target.type === "checkbox" ? target.checked : target.value;
      const name = target.name;
      let FormValues = this.state.form;
      FormValues[name].value = value;
      if (target.name === "fullName") {
        FormValues[name].value = this.removeNonLetters(value);
      }
      this.setState({
        form: FormValues,
      });
    }
  }

  handleSwitch(selected, field) {
    let FormValues = this.state.form;
    let valueSelected = selected ? true : false;
    let carousel = this.state.carousel;
    this.setState({ currentMessage: valueSelected });
    if (!valueSelected) {
      carousel["isActive"] = false;
      carousel["itemSelected"] = {};
      carousel["hourSelected"] = "";
      this.setState({ carousel: carousel });
    }

    FormValues[field]["value"] = valueSelected;
    this.setState({ form: FormValues });
  }

  handleSelect(item) {
    let FormValues = this.state.form;
    FormValues["identificationType"].value = item.CSDocumentoIdentidadText;
    this.setState({
      form: FormValues,
    });
  }

  handleNotificaciones() {
    let tipoDocumento = this.state.typeDocList.filter(
      (item) => item.CSSiglaText == this.props.form.identificationType.sigla
    );
    let body = {
      NotificacionExterna: {
        CodigoTipoNotificacion: 92,
        CodigoMedioNotificacion: 2,
        Asunto: "Informacion de cotizacion Plan Vital Compensar",
        TipoDocumento: tipoDocumento[0].CSIdDocumentoText,
        NumeroDocumento: this.props.form.identificationNumber.value,
        Destino: this.props.form.email.value,
        Parametros: [
          {
            Key: "NombreContratante",
            Value: this.props.form.name.value,
          },
          {
            Key: "PrecioMesual",
            Value: this.props.precio,
          },
          {
            Key: "NumeroAfiliados",
            Value: this.props.form.lessthan60.value,
          },
          {
            Key: "TotalAfiliados",
            Value: this.props.form.lessthan60.value * this.props.precio,
          },
          {
            Key: "ValorTotal",
            Value: this.props.form.lessthan60.value * this.props.precio,
          },
        ],
        Documentos: [],
      },
    };
    const traceabilityQuoting = new ServicioProxy("NotificacionExterna");
    traceabilityQuoting.getElements("POST", body).then((response) => {
      console.log(response);
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    let userInfoCheck = compTools.obtenerInformacionUsuario();

    dataLayer.push({
      event: "cotizacion_plan",
      user_id: userInfoCheck.Nautcli,
      log_status: "true",
      login_type: userInfoCheck.TipoIdentificacion == 2 ? "Empresas" : "Personas",
      affiliation: "Salud",
      bread_crumbs: this.UrlCatcher(),
      step: "Paso 3",
      option: this.props.planvital ? "Cotiza Plan Vital" : "Cotiza Plan Complementario Especial",
      action: "Enviar"
    });

    this.setState({ isSubmitted: true });
    let errors = 0;
    let currentForm = JSON.parse(JSON.stringify(this.state.form));
    this.saludValidaciones.validateForm(currentForm);
    this.setState({ form: currentForm });
    let idCotizacion = sessionStorage.getItem("idCotizacion");

    let params = {
      IdLista: this.pnpService.getIdsListas().trazabilidadCotizador.id,
      IdListaBeneficiario:
        this.pnpService.getIdsListas().trazabilidadCotizadorDetalle.id,
      UrlSitio: _spPageContextInfo.webAbsoluteUrl,
      Datos: {
        TarifaMes: this.props.summary.monthlyFare,
        ValorContrato: this.props.summary.total,
        ContactoTelefonoMovil: this.state.form.phone
          ? this.state.form.phone.value
          : "",
      },
      Simulacion: {
        PrecioMensualDesde: this.props.summary.monthlyFare,
        DescuentoEps: this.props.summary.epsDiscount,
        DescuentoCajaCompensacion: this.props.summary.cajaDiscount,
        UsuariosMenorEdadDefinida: {
          CantidadUsuarios: this.props.summary.lessthan60quantity,
          ValorTotal: this.props.summary.lessthan60total,
        },
        UsuariosMayorEdadDefinida: {
          CantidadUsuarios: this.props.summary.morethan60quantity,
          ValorTotal: this.props.summary.morethan60total,
        },
        UsuariosTotal: {
          CantidadUsuarios: this.props.summary.totalQuantity,
          ValorTotal: this.props.summary.total,
        },
      },
      Interesado: {
        TipoDeDocumento: this.state.form.identificationType.sigla,
        NumeroDeDocumento: this.state.form.identificationNumber.value,
        Nombre: this.state.form.fullName.value,
      },
      Beneficiario: [],
      IdCotizacion: idCotizacion,
    };
    if (this.props.planvital) {
      params["EsPlanVital"] = true;
      params["PlanVitalRequest"] = {
        NombreContratante: this.state.form.fullName.value,
        PrecioMensualDesde: this.props.precio,
        CantidadAfiliados: this.props.form.lessthan60.value,
        Email: this.state.form.email.value,
      };
      this.handleNotificaciones();
    }
    if (this.state.form.confirmEmailMessage.value) {
      params["Datos"]["ContactoCorreo"] = this.state.form.email
        ? this.state.form.email.value
        : "";
    }

    const traceabilityQuoting = new ServicioProxy("GuardarSimulacionCotizador");
    const date = new Date(this.state.carousel.itemSelected.date);
    if (currentForm["isValid"] && !this.state.form.confirmPersonalData.value) {
      //Data Origen Información - Básico
      params["Datos"]["TipoConsulta"] = "Simulaciones No autorizadas";
    } else if (currentForm["isValid"]) {
      params["Datos"]["TipoConsulta"] = "Simulaciones autorizadas";
      params["Datos"]["Categoria"] =
        this.props.form && this.props.form.cajaCategory
          ? this.props.form.cajaCategory.value
          : null;
      params["Datos"]["EPSCompensar"] =
        this.props.form && this.props.form.eps.value ? "8" : "111";
      params["Datos"]["AceptoInfoMensMovil"] = this.state.form
        .confirmTextMessage.value
        ? "Si"
        : "No";
      params["Datos"]["AutorizoDatosPersonales"] = this.state.form
        .confirmPersonalData.value
        ? "Si"
        : "No";
      params["Datos"]["CSAceptoInfoEmailText"] = this.state.form
        .confirmEmailMessage.value
        ? "Si"
        : "No";

      params["Datos"]["ContactoFecha"] = this.state.carousel.itemSelected.date
        ? "/Date(" + date.getTime() + ")/"
        : null;
      params["Datos"]["ContactoHorario"] = this.state.carousel.hourSelected
        ? this.state.carousel.hourSelected
        : null;

      params["Interesado"] = {
        TipoDeDocumento: this.state.form.identificationType.value
          ? this.getDocType(this.state.form.identificationType.value)
          : this.state.form.identificationType.value,
        NumeroDeDocumento: this.state.form.identificationNumber.value,
        Nombre: this.state.form.fullName.value,
      };

      let moreThan60 = [];
      let lessThan60 = [];
      moreThan60 = this.getsubscribed(this.props.subscribed.morethan60);
      lessThan60 = this.getsubscribed(this.props.subscribed.lessthan60);
      params["Beneficiario"] = moreThan60.concat(lessThan60);

      if (compTools.estaAutenticado()) {
        params["Datos"]["Parentesco"] =
          this.props.form && this.props.form.relationship
            ? this.props.form.relationship.value
            : "";
        params["Datos"]["Nit"] =
          this.props.form && this.props.form.nit.value
            ? this.props.form.nit.value
            : null;

        params["Interesado"]["Edad"] =
          this.props.form && this.props.form.age
            ? this.props.form.age.value
            : 0;
        params["Interesado"]["Genero"] =
          this.props.form && this.props.form.gender
            ? this.props.form.gender.value
            : null;
      }
    }

    if (
      (currentForm["isValid"] && !this.state.form.isContacted.value) ||
      (currentForm["isValid"] &&
        this.state.form.isContacted.value &&
        this.state.carousel.itemSelected.date &&
        this.state.carousel.hourSelected !== "" &&
        this.state.form.confirmPersonalData.value)
    ) {
      this.setState({ isDisabled: false });
      traceabilityQuoting
        .getElements("POST", params)
        .then((response) => {
          this.setState({ registeredNumber: response });
          this.setState({ container: false });
        })
        .catch((error) => console.error(error));
    }
  }

  handleBlur(event, elementId) {
    let currentForm = JSON.parse(JSON.stringify(this.state.form));
    let element = event.target;
    this.saludValidaciones.validateField(element, currentForm);
    this.setState({ form: currentForm });
  }

  handleFocus(event) {
    let currentForm = JSON.parse(JSON.stringify(this.state.form));
    if (!event.target.value) {
      currentForm[event.target.id].value = "@";
      this.setCursorAtBegin();
    }
    this.setState({ form: currentForm });
  }

  setCursorAtBegin() {
    let currentForm = JSON.parse(JSON.stringify(this.state.form));
    if (currentForm["email"].value == "@") {
      const input = document.getElementById("email");
      input.setSelectionRange(0, 0);
    } else if (currentForm["confirmEmail"].value == "@") {
      const input = document.getElementById("confirmEmail");
      input.setSelectionRange(0, 0);
    }
  }

  selectedDate(item) {
    let carousel = this.state.carousel;
    carousel["isActive"] = true;
    carousel["itemSelected"] = item;
    this.setState({ carousel: carousel });
    this.updateName(item);
  }

  activeHours(hour) {
    let carousel = this.state.carousel;
    carousel["hourSelected"] = hour;
    this.setState({ currentMessage: false });
    this.setState({ carousel: carousel });
  }

  updateName(item) {
    let monthName = moment(new Date(item.date)).format("MMMM", true);
    this.setState({ monthName: monthName });
  }

  UrlCatcher() {
    var ultimaPosicion = window.location.pathname.split("/");
    var nivelAnterior = ultimaPosicion.slice(ultimaPosicion.length - 1);
    var text = "";
    nivelAnterior.forEach((item) => {
      text = text + "/" + item;
    });
    return decodeURI(text).slice(1);
  }

  finishStep() {
    let userInfoCheck = compTools.obtenerInformacionUsuario();

    dataLayer.push({
      event: "cotizacion_plan",
      user_id: userInfoCheck.Nautcli,
      log_status: "true",
      login_type: userInfoCheck.TipoIdentificacion == 2 ? "Empresas" : "Personas",
      affiliation: "Salud",
      bread_crumbs: this.UrlCatcher(),
      option: this.props.planvital ? "Cotiza Plan Vital" : "Cotiza Plan Complementario Especial",
      step: "Paso 4",
    })
    this.props.handleHide();
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="send-simulation-container modal-wrap">
          {this.state.container ? (
            <div className="form-wrap">
              <form className="form-horizontal" data-list-name="sp-forms-form">
                <div className="col-md-10 col-md-offset-1 col-md-offset-right-1 col-sm-10 col-sm-offset-1 col-sm-offset-right-1 col-xs-12 clearfix">
                  <div
                    className={
                      "form-group margin-sides-30" +
                      (this.state.form.fullName.valid ? "" : " has-error")
                    }
                  >
                    <label
                      htmlFor="fullName"
                      className="col-md-4 col-sm-4 col-xs-12 control-label"
                    >
                      <span>Nombre: *</span> <br />
                      <span className="detail-label">
                        Nombre completo con apellidos
                      </span>
                    </label>
                    <div className="col-md-8 col-sm-8 col-xs-12">
                      <input
                        type="text"
                        id="fullName"
                        name="fullName"
                        className="form-control"
                        tabIndex="0"
                        maxLength="105"
                        value={this.state.form.fullName.value}
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                        placeholder="Ingresa tus nombres"
                        autocomplete="off"
                      />
                      <p
                        className={
                          this.state.form.fullName.valid ? "hidden" : "error"
                        }
                      >
                        Nombre completo{" "}
                        {this.errorMessages[this.state.form.fullName.error]}
                      </p>
                    </div>
                  </div>
                  <div className="form-group margin-sides-30">
                    <label
                      htmlFor="identificationNumber"
                      className="col-md-4 col-sm-4 col-xs-12 control-label"
                    >
                      <span>Documento de Identidad*</span> <br />
                      <span className="detail-label">
                        Ingresa los números sin puntos
                      </span>
                    </label>
                    <div className="col-md-8 col-sm-8 col-xs-12">
                      <div className="row">
                        <div
                          className={
                            "col-md-4 col-sm-5 col-xs-6" +
                            ((this.state.form.identificationType.value ===
                              "Seleccionar" &&
                              !this.state.isSubmitted) ||
                              this.state.form.identificationType.value !==
                              "Seleccionar"
                              ? ""
                              : " has-error")
                          }
                        >
                          <DropdownButton
                            title={this.state.form.identificationType.value}
                            id="identificationType"
                            className="dropdown-custom"
                            bsStyle="Primary"
                          >
                            {this.state.typeDocList.map((item) => {
                              return (
                                <MenuItem
                                  key={item.CSIdDocumentoText}
                                  eventKey={item.CSDocumentoIdentidadText}
                                  className={
                                    this.state.form.identificationType.value ===
                                      item.CSDocumentoIdentidadText
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() => this.handleSelect(item)}
                                >
                                  <span>{item.CSDocumentoIdentidadText}</span>
                                </MenuItem>
                              );
                            })}
                          </DropdownButton>
                          <p
                            className={
                              (this.state.form.identificationType.value ===
                                "Seleccionar" &&
                                !this.state.isSubmitted) ||
                                this.state.form.identificationType.value !==
                                "Seleccionar"
                                ? "hidden"
                                : "error"
                            }
                          >
                            Tipo de documento es requerido
                          </p>
                        </div>
                        <div
                          className={
                            "col-md-8 col-sm-7 col-xs-6" +
                            (this.state.form.identificationNumber.valid
                              ? ""
                              : " has-error")
                          }
                        >
                          <input
                            type="text"
                            id="identificationNumber"
                            name="identificationNumber"
                            className="form-control"
                            tabIndex="1"
                            maxLength={12}
                            value={this.state.form.identificationNumber.value}
                            onChange={this.handleInputChange}
                            onBlur={this.handleBlur}
                            placeholder="Ingresa el número"
                            autocomplete="off"
                          />
                          <p
                            className={
                              this.state.form.identificationNumber.valid
                                ? "hidden"
                                : "error"
                            }
                          >
                            Documento de Identidad{" "}
                            {
                              this.errorMessages[
                              this.state.form.identificationNumber.error
                              ]
                            }
                          </p>
                        </div>
                      </div>
                      <p className="detail-dropdown">
                        Tu número de documento es importante para la afiliación
                      </p>
                    </div>
                  </div>
                  <div
                    className={
                      "form-group margin-sides-30" +
                      (this.state.form.phone.valid ? "" : " has-error")
                    }
                  >
                    <label
                      htmlFor="phone"
                      className="col-md-4 col-sm-4 col-xs-12 control-label"
                    >
                      Teléfono Móvil:*
                    </label>
                    <div className="col-md-8 col-sm-8 col-xs-12">
                      <input
                        type="text"
                        id="phone"
                        name="phone"
                        className="form-control input-med-size"
                        pattern=".{10,10}"
                        tabIndex="3"
                        maxLength={10}
                        minLength={10}
                        value={this.state.form.phone.value}
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                        placeholder="Ingresa tu teléfono móvil"
                        autocomplete="off"
                      />
                      <p
                        className={
                          this.state.form.phone.valid ? "hidden" : "error"
                        }
                      >
                        Teléfono Móvil{" "}
                        {this.errorMessages[this.state.form.phone.error]}
                      </p>
                    </div>
                  </div>
                  <div
                    className={
                      "form-group margin-sides-30" +
                      (this.state.form.email.valid ? "" : " has-error")
                    }
                  >
                    <label
                      htmlFor="email"
                      className="col-md-4 col-sm-4 col-xs-12 control-label"
                    >
                      ¿Cúal es tu correo personal?
                    </label>
                    <div className="col-md-8 col-sm-8 col-xs-12">
                      <input
                        type="text"
                        id="email"
                        name="email"
                        className="form-control input-med-size"
                        tabIndex="4"
                        maxLength="245"
                        value={this.state.form.email.value}
                        onPaste={(e) => e.preventDefault()}
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                        onFocus={this.handleFocus}
                        onClick={this.setCursorAtBegin}
                        placeholder="Ingresa tu correo electrónico"
                        autocomplete="off"
                      />
                      {this.state.form.email.valid &&
                        this.state.form.email.value !== "" ? (
                        <span className="check-container">
                          <i
                            className={
                              "fa " +
                              (this.state.form.email.valid &&
                                this.state.form.email.value !== ""
                                ? "fa-check "
                                : "")
                            }
                          ></i>
                        </span>
                      ) : (
                        ""
                      )}
                      {this.state.form.email.value === "@" ? (
                        <p
                          className={
                            this.state.form.email.valid ? "hidden" : "error"
                          }
                        >
                          {this.props.configurations.MensajeCorreoRequerido}
                        </p>
                      ) : (
                        <p
                          className={
                            this.state.form.email.valid ? "hidden" : "error"
                          }
                        >
                          {this.props.configurations.MensajeCorreoInvalido}
                        </p>
                      )}
                    </div>
                  </div>
                  <div
                    className={
                      "form-group margin-sides-30" +
                      (this.state.form.confirmEmail.valid ? "" : " has-error")
                    }
                  >
                    <label
                      htmlFor="confirmEmail"
                      className="col-md-4 col-sm-4 col-xs-12 control-label"
                    >
                      <span className="highlighted-text-success">
                        Confírmanos tu correo personal
                      </span>
                    </label>
                    <div className="col-md-8 col-sm-8 col-xs-12">
                      <input
                        onPaste={(e) => e.preventDefault()}
                        type="text"
                        id="confirmEmail"
                        name="confirmEmail"
                        className="form-control input-med-size"
                        tabIndex="5"
                        maxLength="245"
                        value={this.state.form.confirmEmail.value}
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlur}
                        onFocus={(e) => this.handleFocus(e)}
                        onClick={this.setCursorAtBegin}
                        placeholder="Confirma tu correo electrónico"
                        autocomplete="off"
                      />
                      {this.state.form.confirmEmail.valid &&
                        this.state.form.confirmEmail.value !== "" &&
                        this.state.form.confirmEmail.value !== "@" ? (
                        <span className="check-container">
                          <i
                            className={
                              "fa " + this.state.form.confirmEmail.valid &&
                                this.state.form.confirmEmail.value !== "" &&
                                this.state.form.confirmEmail.value !== "@"
                                ? "fa-check "
                                : ""
                            }
                          ></i>
                        </span>
                      ) : (
                        ""
                      )}
                      {this.state.form.confirmEmail.value === "@" ? (
                        <p
                          className={
                            this.state.form.confirmEmail.valid
                              ? "hidden"
                              : "error"
                          }
                        >
                          {this.props.configurations.MensajeCorreoRequerido}
                        </p>
                      ) : (
                        <p
                          className={
                            this.state.form.confirmEmail.valid
                              ? "hidden"
                              : "error"
                          }
                        >
                          {this.state.form.confirmEmail.error === "equalTo" &&
                            this.state.form.email.value ? (
                            <span>
                              {
                                this.props.configurations
                                  .MensajeCorreoConfirmacion
                              }
                            </span>
                          ) : (
                            <span>
                              {this.props.configurations.MensajeCorreoInvalido}
                            </span>
                          )}
                        </p>
                      )}
                    </div>
                  </div>
                  <div
                    className={
                      "form-group margin-sides-30" +
                      (this.state.currentMessage && this.state.isSubmitted
                        ? " has-error"
                        : "")
                    }
                  >
                    <div className="option-container margin-sides-30">
                      <label
                        htmlFor="isContacted"
                        className="col-md-4 col-sm-4 col-xs-6 control-label"
                      >
                        <span> ¿Quieres ser contactado </span> <br />
                        <span>por un asesor de compensar?</span>
                      </label>
                      <div className="col-md-8 col-sm-8 col-xs-6">
                        <div className="cs-switch" id="isContacted">
                          <div
                            tabIndex="6"
                            className={
                              "cs-switch-option" +
                              (this.state.form.isContacted.value
                                ? `${this.props.planvital
                                  ? " cs-switch-option-planvital"
                                  : " active"
                                }`
                                : "")
                            }
                            onClick={() =>
                              this.handleSwitch(true, "isContacted")
                            }
                          >
                            Si
                          </div>
                          <div
                            tabIndex="7"
                            className={
                              "cs-switch-option" +
                              (!this.state.form.isContacted.value
                                ? `${this.props.planvital
                                  ? " cs-switch-option-planvital"
                                  : " active"
                                }`
                                : "")
                            }
                            onClick={() =>
                              this.handleSwitch(false, "isContacted")
                            }
                          >
                            No
                          </div>
                        </div>
                      </div>
                      {this.state.form.isContacted.value ? (
                        <div className="col-md-12 col-sm-12 col-xs-12">
                          <br />
                          <label
                            htmlFor="isContacted"
                            className={
                              "control-label " +
                              (this.state.currentMessage &&
                                this.state.isSubmitted
                                ? "error"
                                : "")
                            }
                          >
                            Seleccione una Fecha y Hora para contactarlo
                          </label>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="clearfix">
                  {this.state.form.isContacted.value ? (
                    <div className="shedule-container">
                      {this.state.shedule.length > 0 ? (
                        <div className="col-md-10 col-md-offset-1 col-md-offset-right-1 col-sm-10 col-sm-offset-1 col-sm-offset-right-1 col-xs-12">
                          <h3
                            className={
                              "title-date-container " +
                              (this.state.currentMessage &&
                                this.state.isSubmitted &&
                                !this.state.carousel.itemSelected.date
                                ? "error"
                                : "hidden")
                            }
                          >
                            Selecciona un dia para contactarte*
                          </h3>
                          {/* <h4 className="title-month-container">{ this.state.monthName }</h4> */}
                        </div>
                      ) : null}
                      {this.state.shedule.length > 0 ? (
                        <Slider {...this.state.carousel.settings}>
                          {this.state.shedule.map((item, key) => {
                            return (
                              <div
                                className={
                                  "date-container date-container-" +
                                  key +
                                  (item.line ? " border-slide" : "")
                                }
                                key={key}
                                style={{ width: 100 }}
                              >
                                <h4 className="title-month-container">
                                  {item.monthVisible
                                    ? moment(new Date(item.date)).format(
                                      "MMM",
                                      true
                                    )
                                    : ""}
                                </h4>
                                <button
                                  id="selected-date"
                                  type="button"
                                  className={
                                    "btn btn-date-detail " +
                                    (item.date ===
                                      this.state.carousel.itemSelected.date &&
                                      this.state.carousel.itemSelected.date
                                      ? this.props.planvital
                                        ? "btn-date-activePlanvital"
                                        : "btn-date-active"
                                      : this.props.planvital
                                        ? "btn-date-detailPlanVital"
                                        : "")
                                  }
                                  onClick={() => this.selectedDate(item)}
                                >
                                  <div className="date-detail">
                                    <dd className="day-name">
                                      {moment(new Date(item.date)).format(
                                        "ddd",
                                        true
                                      )}
                                    </dd>
                                    <dd className="day">
                                      {moment(new Date(item.date)).format(
                                        "DD",
                                        true
                                      )}
                                    </dd>
                                    <dd className="year">
                                      {moment(new Date(item.date)).format(
                                        "YYYY",
                                        true
                                      )}
                                    </dd>
                                  </div>
                                </button>
                              </div>
                            );
                          })}
                        </Slider>
                      ) : (
                        <p>
                          En este momento no hay una Agenda disponible, por
                          favor pongase en contacto con un Administrador.
                        </p>
                      )}
                      {this.state.carousel.isActive ? (
                        <div className="hours-container">
                          <div className="col-md-10 col-md-offset-1 col-md-offset-right-1 col-sm-10 col-sm-offset-1 col-sm-offset-right-1 col-xs-12">
                            <dt>
                              <h3
                                className={
                                  "title-hour-container " +
                                  (this.state.currentMessage &&
                                    this.state.isSubmitted &&
                                    !this.state.carousel.hourSelected
                                    ? "error"
                                    : "hidden")
                                }
                              >
                                Selecciona un hora ideal contactarte*
                              </h3>
                            </dt>
                            {this.state.carousel.itemSelected &&
                              this.state.carousel.itemSelected.hours &&
                              this.state.carousel.itemSelected.hours.map(
                                (el) => {
                                  return (
                                    <dd key={el}>
                                      <button
                                        id="selected-hours"
                                        type="button"
                                        className={
                                          "btn btn-hour-detail " +
                                          (el ===
                                            this.state.carousel.hourSelected
                                            ? this.props.planvital
                                              ? "btn-hour-activePlanvital"
                                              : "btn-hour-active"
                                            : this.props.planvital
                                              ? "btn-hour-detailPlanvital"
                                              : "")
                                        }
                                        onClick={() => this.activeHours(el)}
                                      >
                                        <i
                                          className={
                                            el.indexOf("am") > 0
                                              ? "wi wi-day-sunny"
                                              : el.indexOf("5") > 0
                                                ? "wi wi-horizon-alt"
                                                : "fa fa-moon-o"
                                          }
                                        ></i>
                                        <p>
                                          <span>{el}</span>
                                        </p>
                                      </button>
                                    </dd>
                                  );
                                }
                              )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                {/* <div className="col-md-10 col-md-offset-1 col-md-offset-right-1 col-sm-10 col-sm-offset-2 col-xs-11 col-xs-offset-1">
                  <div className={'form-group margin-sides-30 no-margin-btm ' + (this.state.form.isContacted.value && !this.state.form.confirmPersonalData.value && this.state.isSubmitted ? ' has-error' : '')}>
                    <div className="col-md-9 col-md-offset-2 col-md-offset-right-1 col-sm-12 col-xs-12 margin-btn-10 chk-container">
                      <input type="checkbox" id="confirmPersonalData" className="chk-style" name="confirmPersonalData" checked={this.state.form.confirmPersonalData.value} onChange={this.handleInputChange} autocomplete="off" />
                      <label htmlFor="confirmPersonalData" className="control-label chk-label"><span className="detail-label"><a target="_blank" href={_spPageContextInfo.webAbsoluteUrl + '/Documents/Proteccion%20de%20datos.pdf'}> { this.props.configurations.AutorizoDatosPersonales }</a></span></label>
                      <p className={this.state.form.isContacted.value && !this.state.form.confirmPersonalData.value && this.state.isSubmitted ? 'error' : 'hidden'}>Autorización de tratamiento de los datos personales { this.errorMessages['required'] }</p>
                    </div>
                  </div>
                  <div className="form-group margin-sides-30">
                    <div className="col-md-9 col-md-offset-2 col-md-offset-right-1 col-sm-12 col-xs-12 margin-btn-10 chk-container">
                      <input type="checkbox" id="confirmEmailMessage" className="chk-style" name="confirmEmailMessage" checked={this.state.form.confirmEmailMessage.value} onChange={this.handleInputChange} autocomplete="off" />
                      <label htmlFor="confirmEmailMessage" className="control-label chk-label"><span className="detail-label">{ this.props.configurations.AceptoInformacionCorreo }</span></label>
                    </div>
                    <div className="col-md-9 col-md-offset-2 col-md-offset-right-1 col-sm-12 col-xs-12 margin-btn-10 chk-container">
                      <input type="checkbox" id="confirmTextMessage" className="chk-style" name="confirmTextMessage" checked={this.state.form.confirmTextMessage.value} onChange={this.handleInputChange} autocomplete="off" />
                      <label htmlFor="confirmTextMessage" className="control-label chk-label"><span className="detail-label">{ this.props.configurations.AceptoMensajesTexto }</span></label>
                    </div>
                  </div> 
                </div> */}
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <hr className="hr-line-div-elem" />
                  <div className="form-group">
                    <div className="col-md-12  col-sm-12 col-xs-12 center-text">
                      <button
                        id="submit-form"
                        type="submit"
                        className={
                          this.props.planvital
                            ? "btn btn-primary-planvital "
                            : "btn btn-primary"
                        }
                        onClick={this.handleSubmit}
                        disabled={!this.state.isDisabled}
                      >
                        Enviar <i className="fa fa-paper-plane-o"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          ) : (
            <div id="message-container">
              <h2 className="title-name"> {this.state.form.fullName.value} </h2>
              <h1 className="message-title">
                {this.props.configurations.TextoAgradecimiento}
              </h1>
              {this.state.form.confirmEmailMessage.value ? (
                <div>
                  <div>
                    {this.state.form.isContacted.value ? (
                      <div>
                        <p className="message-text no-margin-btm">
                          {this.props.planvital
                            ? this.props.configurations
                              .TextoEnvioCorreoRadicadoPlanVital
                            : this.props.configurations
                              .TextoEnvioCorreoRadicado}
                        </p>
                        <p className="message-text">
                          {this.props.planvital
                            ? this.props.configurations
                              .TextoNumeroRadicadoPlanVital +
                            " " +
                            this.state.registeredNumber
                            : this.props.configurations.TextoMensajeTuRadicado +
                            " " +
                            this.state.registeredNumber}
                        </p>
                      </div>
                    ) : (
                      <p className="message-text">
                        {this.props.planvital
                          ? this.props.configurations.TextoEnvioCorreoPlanVital
                          : this.props.configurations.TextoEnvioCorreo}
                      </p>
                    )}
                  </div>
                  <hr className="hr-line-div-elem" />
                </div>
              ) : (
                <div>
                  {this.state.form.isContacted.value ? (
                    <div>
                      <p className="message-text no-margin-btm">
                        {
                          this.props.configurations
                            .TextoEnvioCorreoNoAceptoRecibirInformacion
                        }
                      </p>
                      <p className="message-text">
                        {this.props.planvital
                          ? this.props.configurations.TextoEnvioCorreoPlanVital
                          : this.props.configurations.TextoMensajeTuRadicado +
                          " " +
                          this.state.registeredNumber}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
              {this.state.carousel.itemSelected.date ? (
                <div>
                  <ul className="schedule-detail">
                    <li>
                      <i className="fa fa-calendar calendar"></i>
                    </li>
                    <li>
                      <div>
                        <h3>Día</h3>
                        <p>
                          {moment(
                            new Date(this.state.carousel.itemSelected.date)
                          ).format("DD", true)}
                        </p>
                      </div>
                    </li>
                    <li>
                      <div>
                        <h3>Mes</h3>
                        <p>
                          {moment(
                            new Date(this.state.carousel.itemSelected.date)
                          ).format("MMM", true)}
                        </p>
                      </div>
                    </li>
                    <li>
                      <div>
                        <h3>Hora</h3>
                        <p>{this.state.carousel.hourSelected}</p>
                      </div>
                    </li>
                  </ul>
                  <hr className="hr-line-div-elem" />
                </div>
              ) : null}
              <div className="btn-container">
                <button
                  id="finish-send-simulation"
                  type="button"
                  className={
                    this.props.planvital
                      ? "btn btn-primary-planvital btn-finish"
                      : "btn primary btn-finish"
                  }
                  onClick={() => this.finishStep()}
                >
                  Terminar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      type="button"
      className={className}
      style={{ ...style }}
      onClick={onClick}
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      type="button"
      className={className}
      style={{ ...style }}
      onClick={onClick}
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
}

/******************** BUILD ********************/
const DropdownButton = ReactBootstrap.DropdownButton;
const MenuItem = ReactBootstrap.MenuItem;
/******************** BUILD ********************/

export default EnviarSimulacionFormulario;
